import { Injectable } from '@angular/core';
import { MatterTitle } from '@models/matter';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './titles.actions';

@Injectable({
	providedIn: 'root',
})
export class MatterTitlesDispatch {
	@Dispatch()
	CreateOrUpdate = (parcel: MatterTitle): actions.CreateOrUpdate =>
		new actions.CreateOrUpdate(parcel);

	@Dispatch()
	Remove = (parcelId: string): actions.Remove => new actions.Remove(parcelId);
}
